import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
// import Tilt from "react-parallax-tilt";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I’m a Software Engineer who loves transforming ideas into
              reliable, scalable products. Over time, I’ve explored several
              technologies and found my passion in building high-performance
              systems and intuitive user experiences.
              <br />
              <br />
              I am proficient in
              <i>
                <b className="purple">
                  {" "}
                  REACT, TypeScript, JavaScript, PHP, Flutter {" "}
                </b>
              </i>
              — and I enjoy working across both backend and frontend stacks.
              <br />
              <br />
              Passionate about creating
              <i>
                <b className="purple">
                  {" "}
                  Web, Mobile, and Desktop Applications,{" "}
                </b>
              </i>
              and constantly exploring new technologies to grow as a developer.
              <br />
              <br />
              Whenever possible, I love building projects with
              <b className="purple"> React, Flutter </b> and modern frameworks like{" "}
              <i>
                <b className="purple">Tauri</b>{" "}
                <b className="purple"></b>.
              </i>
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            {/* <Tilt> */}
              <img src={myImg} className="img-fluid" alt="avatar" />
            {/* </Tilt> */}
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
